"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4420],{

/***/ 34420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HubspotSideBySideFormComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js
var side_by_side_text_and_asset = __webpack_require__(59526);
// EXTERNAL MODULE: ./segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form.js + 2 modules
var hubspot_contact_form = __webpack_require__(78235);
// EXTERNAL MODULE: ./segments/desktop/core-components/hubspot-contact-form/default-props.js
var default_props = __webpack_require__(95472);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-side-by-side-form/hubspot-side-by-side-form-component.scss.js



var HEADER_LOGO_HORIZONTAL_PADDING = "".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var MAX_DESKTOP_CONTENT_WIDTH_PX = "".concat(vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$, "px");
var XS_PX = "".concat(vp_sizes.XS, "px");
var StyledHubspotSideBySideFormComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1vb5tci0"
})("margin:auto;&.align-to-logo{padding-left:", HEADER_LOGO_HORIZONTAL_PADDING, ";padding-right:", HEADER_LOGO_HORIZONTAL_PADDING, ";}@media (min-width:", XS_PX, ") and (max-width:", MAX_DESKTOP_CONTENT_WIDTH_PX, "){.full-paragraph-component-wrapper{padding:0 20px 20px 20px !important;}}@media (max-width:", XS_PX, "){.side-by-side-content{padding:0 64px;.full-paragraph-component-wrapper{padding:0 20px 20px 20px !important;}}}");

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-side-by-side-form/hubspot-side-by-side-form-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var HubspotSideBySideFormComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HubspotSideBySideFormComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HubspotSideBySideFormComponent);
    function HubspotSideBySideFormComponent() {
        (0,_class_call_check/* default */.Z)(this, HubspotSideBySideFormComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(HubspotSideBySideFormComponent, [
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, formId = _this_props.formId, source = _this_props.source, overrideCampaignId = _this_props.overrideCampaignId, lastNameFirst = _this_props.lastNameFirst, urlToRedirectAfterSubmission = _this_props.urlToRedirectAfterSubmission, restProps = _object_without_properties(_this_props, [
                    "formId",
                    "source",
                    "overrideCampaignId",
                    "lastNameFirst",
                    "urlToRedirectAfterSubmission"
                ]);
                var replaceTextComponentProps = {
                    formId: formId,
                    source: source,
                    overrideCampaignId: overrideCampaignId,
                    lastNameFirst: lastNameFirst,
                    urlToRedirectAfterSubmission: urlToRedirectAfterSubmission
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHubspotSideBySideFormComponent, {
                    className: "hubspot-side-by-side-form-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, _object_spread_props(_object_spread({
                        replaceTextComponent: hubspot_contact_form/* default */.Z
                    }, restProps), {
                        replaceTextComponentProps: replaceTextComponentProps
                    }))
                });
            }
        }
    ]);
    return HubspotSideBySideFormComponent;
}(react.PureComponent);

HubspotSideBySideFormComponent.defaultProps = _object_spread({
    width: "100%",
    asset: {
        position: "center",
        fitToContainer: true,
        image: {
            src: "/static/img/segment-layout-default-images/sales_social.png"
        }
    }
}, default_props/* default */.Z);


/***/ })

}]);